import * as React from "react";
import styled from "styled-components";
import { px2rem } from "common/helpers/rem";

const Wrapper = styled.div`
  margin-top: ${px2rem(16)};
`;

const AnimatedBar = styled.div`
  background: linear-gradient(
    to right,
    ${props => props.theme.grey100} 0%,
    ${props => props.theme.grey500} 20%,
    ${props => props.theme.grey100} 40%,
    ${props => props.theme.grey100} 100%
  );
  background-size: 400% 400%;

  animation: load 5s ease infinite;

  @keyframes load {
    0% {
      background-position: 0 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0 50%;
    }
  }
`;

const ProfilePlacement = styled.div`
  display: flex;
  align-items: center;
  margin: ${px2rem(16)};

  .info {
    flex: 1;
  }
`;

const ImageBox = styled(AnimatedBar)`
  width: ${px2rem(32)};
  height: ${px2rem(32)};
  border-radius: 50%;
  background-color: #ebebeb;
  margin-right: ${px2rem(8)};
`;

const ProfileLine1 = styled(AnimatedBar)`
  width: ${px2rem(75)};
  height: ${px2rem(8)};
`;
const ProfileLine2 = styled(AnimatedBar)`
  width: ${px2rem(43)};
  height: ${px2rem(8)};
  margin-top: ${px2rem(4)};
`;

const Bar1 = styled(AnimatedBar)`
  width: ${px2rem(267)};
  height: ${px2rem(20)};
  margin: 0 0 ${px2rem(16)} ${px2rem(16)};
`;

const Box = styled(AnimatedBar)`
  width: ${px2rem(320)};
  height: ${px2rem(206)};
`;

const Bar2 = styled(AnimatedBar)`
  width: ${px2rem(247)};
  height: ${px2rem(8)};
  margin: ${px2rem(16)} 0 0 ${px2rem(14)};
`;

const Bar3 = styled(AnimatedBar)`
  width: ${px2rem(162)};
  height: ${px2rem(8)};
  margin: ${px2rem(8)} 0 0 ${px2rem(14)};
`;

const LoadingIndicator = () => {
  return (
    <Wrapper>
      <ProfilePlacement>
        <ImageBox />

        <div className="info">
          <ProfileLine1 />
          <ProfileLine2 />
        </div>
      </ProfilePlacement>

      <Bar1 />

      <Box />

      <Bar2 />
      <Bar3 />
    </Wrapper>
  );
};

export default LoadingIndicator;
